import {Pipe, PipeTransform} from '@angular/core';
import {EquipmentEnums} from '@namespaces/equipment.namespace';
import {Calibration} from '@models/card/calibration';

/**
 * Выбор нужной формулировки о поверке или калибровке в зависимости от статуса, поверяется это оборудование или калибруется
 * Если не поверяется и не калибруется, используется дефолтное значение
 *
 * Используется как
 * equipment.apparatus.verification_status | calibrationLabel : 'Поверка' : 'Калибровка' : 'Поверка/Калибровка'
 * либо как
 * equipment.apparatus.verification_status | calibrationLabel : 'Поверка' : 'Калибровка'
 * и тогда дефолтным будет первое значение
 */
@Pipe({name: 'calibrationLabel'})
export class CalibrationLabelPipe implements PipeTransform {
    /**
     * @param status
     * @param ongoingLabel - лейбл для поверки
     * @param calibratedLabel - для калибровки
     * @param defaultLabel - дефолтное, если не поверяется
     */
    transform(status: EquipmentEnums.VerificationStatus, ongoingLabel: string, calibratedLabel: string, defaultLabel?: string): string {
        return Calibration.getCalibrationLabel(status, ongoingLabel, calibratedLabel, defaultLabel);
    }
}

